import { sendExportRequest } from "@/v2-backoffice-client/components/table/export/table.export"

/**
 * Downloads the fill-in invitation template as a real workbook (.xlsx opens
 * with correct columns in every Excel/Sheets locale — no CSV delimiter
 * guessing). Produced by the same backoffice-api /export/excel endpoint the
 * tables use. Headers match the paste-import's aliases, and the example row
 * uses a reserved documentation domain so a forgotten row can never reach a
 * real mailbox.
 */
export function downloadInvitationTemplate() {
  return sendExportRequest({
    fileName: "placepoint-invitations",
    addTimestampToFileName: false,
    columns: [
      { label: "Email" },
      { label: "First name" },
      { label: "Last name" },
      { label: "Team" },
    ],
    rows: [
      ["kari.nordmann@example.com", "Kari", "Nordmann", "Eksempel Eiendom AS"],
    ],
  })
}
